<app-profile-header></app-profile-header>
<section class="body-section">
    <div class="container">


        <main>


            <div class="bottom-container Transaction-table ">
                <div class="box transaction-box Rankinghistory">
                    <div class="header-container">
                        <h3 class="section-header">Ranking History
                        </h3>
                    </div>

                    <p-table #dt [value]="rankingList" dataKey="rank" [paginator]="true" [rows]="10" [lazy]="true"
                        [scrollable]="true" scrollHeight="auto" scrollDirection="both" pageLinks="3" [showPageLinks]="true"
                        (onLazyLoad)="loadRanking($event)" [totalRecords]="totalRecords" [loading]="loading"
                        [rowsPerPageOptions]="paginationOption" [value]="rankingList" responsiveLayout="scroll"  >
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width: 0; min-width: 0px;" class="icons"></th>
                                <th class="rank">Rank </th>
                                <th class="tournamentName">Tournament Name</th>
                                <th class="MatchType">Match-Type</th>
                                <th class="AgeGroup">Age Group </th>
                                <th class="Points">Points </th>
                                <th class="button-table"> </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-rank let-expanded="expanded">
                            <tr class="normal-tr" [ngClass]="expanded ? 'expanded ' : 'normal'"> 
                                <td class="icons">
                                    <button type="button" pButton pRipple [pRowToggler]="rank"
                                        class="p-button-text p-button-rounded p-button-plain"
                                        [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                                </td>
                                <td class="rank">
                                    <span class="mobile-heading-lable">
                                        Rank:
                                    </span>
                                    {{rank.rank}}
                                </td>
                                <td class="tournamentName">
                                    <span class="mobile-heading-lable">
                                        Tournament Name:
                                    </span>
                                    {{rank.tournamentName}}
                                </td>
                                <td class="MatchType">
                                    <span class="mobile-heading-lable">
                                        Category:
                                    </span>
                                    {{rank.categoryName}}
                                </td>
                                <td class="AgeGroup">
                                    <span class="mobile-heading-lable">
                                        Age Group:
                                    </span>
                                    {{rank.agegroupName}}
                                </td>
                                <td class="Points">
                                    <span class="mobile-heading-lable">
                                        Points:
                                    </span>
                                    {{rank.playerRanking}}
                                </td>
                                <td class="button-table">
                                    <button pButton [pRowToggler]="rank"
                                        class="p-button-text p-button-rounded p-button-plain show-btn">Show
                                        Details <span class="expanded-btn-icon"> <i [ngClass]="expanded ? 'pi pi-chevron-down ' : 'pi pi-chevron-right'"></i></span> </button>
                                       
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="rowexpansion" let-rank>
                            <tr dataKey="id"  class="expanded-tr">

                                <td colspan="10">
                                    <div class="accordian-body " id="compare-1">
                                        <div class="compare-table-inner-div">
                                            <div class="close-inner-icon">
                                                <button data-bs-toggle="collapse" data-bs-target="#compare-1"> <i
                                                        class="pi pi-times"></i></button>
                                            </div>
                                            <div class="rin-player-ranks-table-container">
                                                <div class="rin-current-year-ranks">
                                                    <div class="rin-ranks-header">{{currentYear | date:'yyyy'}}</div>
                                                    <div class="rin-current-year-data">
                                                        <div class="rin-ranks-data"><span>{{rank.rank}}</span>
                                                            <span>Current
                                                                Ranking</span>
                                                        </div>
                                                        <div class="rin-ranks-data"><span>
                                                                {{highestRankNumber}}
                                                            </span>
                                                            <span>Highest
                                                                Ranking</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="rin-career-ranks">
                                                    <div class="rin-ranks-header">Career</div>
                                                    <div class="rin-ranks-data"><span>{{highestRankNumber}}</span>
                                                        <span>{{highestRankNumberCreatedAt|date:'dd-MM-yyyy'}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="7" class="not-found-massage-div">
                                    <div class="not-found-section w-100" style="border:none;">
                                        <div class="col-md-12 not-found-body"><img src="assets/img/logo/not-found.gif" alt="">
                                            <h4> Ranking History not found!</h4>
                                            <p>You haven't participated in any tournaments.</p>
                                        </div>
                                    </div>


                                </td>
                            </tr>
                        </ng-template>
                    </p-table>

                </div>
            </div>
            <div class="bottom-container Transaction-table d-none ">
                <div class="box transaction-box ">
                    <div class="header-container">
                        <h3 class="section-header">Ranking Movement
                        </h3>
                        <!-- <div class="date-selector">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 1.5V3.75" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12 1.5V3.75" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M2.625 6.8175H15.375" stroke="#292D32" stroke-width="1.5"
                                    stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M15.75 6.375V12.75C15.75 15 14.625 16.5 12 16.5H6C3.375 16.5 2.25 15 2.25 12.75V6.375C2.25 4.125 3.375 2.625 6 2.625H12C14.625 2.625 15.75 4.125 15.75 6.375Z"
                                    stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M11.7713 10.275H11.778" stroke="#292D32" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M11.7713 12.525H11.778" stroke="#292D32" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.99686 10.275H9.00359" stroke="#292D32" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.99686 12.525H9.00359" stroke="#292D32" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6.22049 10.275H6.22723" stroke="#292D32" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6.22049 12.525H6.22723" stroke="#292D32" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <span>1 Jan - 1 Feb 2022</span>
                        </div> -->
                    </div>
                    <div class="chart border-div">
                      <div class="col-md-12 d-flex justify-content-end">
                        <p-dropdown inputId="yearOptions" [ngModel]="selectedYear" [options]="yearOptions"
                        (onChange)="onClickYear($event)" placeholder="Select year" optionLabel="year"
                        [filter]="true"></p-dropdown>
                      </div>
                        <p-chart type="line" [data]="rankData" [options]="basicOptions"></p-chart>
                    </div>
                </div>
            </div>


        </main>
    </div>
</section>